import {
  Routes,
  Route,
} from "react-router-dom";

import Login from './Login';
import Portal  from './Portal';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/home" element={<Portal />} />
    </Routes>
  );
}

export default App;
